import {
  DateInput,
  FileInput,
  ReferenceInput,
  SelectInput,
  TextInput,
} from "@/components/admin"
import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { TabsContent, TabsTrigger } from "@/components/ui/tabs"
import { required } from "ra-core"
export const PersonalTab = () => {
  return (
    <TabsContent value="personal" className="space-y-6">
      <Card className="p-0 py-4">
        <CardContent className="space-y-6">
          <FileInput
            source="avatar"
            label={false}
            multiple={false}
            accept={{ "image/*": [".png", ".jpg", ".jpeg"] }}
            placeholder={
              <small>
                cliquez ici pour télécharger une nouvelle photo de profil, puis
                enregistrez pour appliquer
              </small>
            }
          ></FileInput>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
            <TextInput
              source="first_name"
              label="Prénom"
              validate={required()}
            />
            <TextInput source="last_name" label="Nom" validate={required()} />
            <TextInput source="email" label="Email" disabled />
            <DateInput source="birthday" label="Date de naissance" />
            <div className="space-y-2">
              <Label htmlFor="jobTitle">Titre du poste</Label>
              <Input
                disabled
                id="jobTitle"
                defaultValue="Senior Product Designer"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="company">Entreprise</Label>
              <Input disabled id="company" defaultValue="Acme Inc." />
            </div>
            <ReferenceInput reference="cities" source="address.city">
              <SelectInput label="Ville" />
            </ReferenceInput>
            <TextInput label="Région" source="address.region" />
          </div>
        </CardContent>
      </Card>
    </TabsContent>
  )
}
export const PersonalTrigger = () => (
  <TabsTrigger
    value="personal"
    className="cursor-pointer flex flex-col items-center gap-1 data-[state=active]:bg-primary dark:data-[state=active]:bg-primary data-[state=active]:text-primary-foreground dark:data-[state=active]:text-primary-foreground dark:data-[state=active]:border-transparent"
  >
    Personnel
  </TabsTrigger>
)
